import { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import classNames from 'classnames'

import s from './FileDropzone.module.css'

// TODO: Setup proptypes
function FileDropzone({
  onDrop,
  file = null,
  disabled = false,
  className = null,
  iconClassName = null,
  hidePreview = false,
}) {
  const handleDrop = useCallback(
    (acceptedFiles) => {
      onDrop(
        acceptedFiles.map((file) => ({
          file,
          preview: URL.createObjectURL(file),
        }))
      )
    },
    [onDrop]
  )
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    disabled,
    onDrop: handleDrop,
    accept: 'image/*',
    multiple: false,
  })

  return (
    <div
      {...getRootProps({
        className: classNames(s.fileInput, className),
      })}
    >
      <input {...getInputProps()} />
      {file && !hidePreview && (
        <img src={file.preview} alt="Preview" className={s.fileInputImage} />
      )}
      {isDragActive ? (
        <p>Drop the files here...</p>
      ) : (
        <p>{file ? 'Change Image' : 'Image Upload'}</p>
      )}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        className={classNames(s.fileInputIcon, iconClassName)}
      >
        <g fill="none" fillRule="evenodd">
          <path fill="#FFF" d="M0 0h20v20H0z" />
          <path
            fill="#000"
            opacity=".5"
            d="M10.306 7v2.449h2.442v.774h-2.442v2.466H9.43v-2.466H7v-.774h2.43V7z"
          />
          <ellipse cx="10" cy="9.558" stroke="#979797" rx="10" ry="9.558" />
        </g>
      </svg>
    </div>
  )
}

export default FileDropzone
